// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC10r-V7FKneviO6jXrdbDCqhzLmvcRfn8",
  authDomain: "floorjanitorial.firebaseapp.com",
  projectId: "floorjanitorial",
  storageBucket: "floorjanitorial.firebasestorage.app",
  messagingSenderId: "401352385530",
  appId: "1:401352385530:web:f51a5a2c8b9df14d4afa43"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Auth, and Storage
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
